module.exports = __webpack_public_path__ + "img/4_84.30134026.png";